export const safeNumberParse = (value: string | null | undefined, defaultValue?: number): number | undefined => {
  if (!value) {
    return defaultValue;
  }

  const parsed = Number(value);

  return Number.isNaN(parsed) ? defaultValue : parsed;
};
